import { DocsAPI } from './api';
export { GuideScene } from './app/slide';
export { FileType } from './file-kit';
export { DocInterface } from './interface/document';
export { MindInterface } from './interface/mind';
export { PDFInterface } from './interface/pdf';
export { SheetInterface } from './interface/sheet';
export { SlideInterface } from './interface/slide';
export { SmartSheetInterface } from './interface/smart-sheet';
export var docs = {
    api: DocsAPI.getInstance(),
};
//# sourceMappingURL=index.js.map